#import '../fragments/userProfile.fragment.graphql'

query userProfile {
  viewer {
    id
    userProfile {
      ...UserProfileFragment
    }
  }
}
